export const formatDate = (date: any, language = 'nb-NO') => {
    if (!date) {
        return null;
    }

    const newDate = new Date(date);
    let locale = '';

    if (language === 'en') {
        locale = 'en-GB';
    } else if (language === '') {
        locale = 'nb-NO';
    } else {
        locale = language;
    }

    return newDate
        .toLocaleDateString(locale, {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        })
        .toLowerCase();
};
